// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { ArrowBackIos } from '@material-ui/icons';
import MediaQuery from 'react-responsive';

import * as contactActions from '../store/actions';
import { getData } from '../store/selectors';
import history from '../../../services/history';
import blueCloud from '../../../images/shape-contact-us.png';
import blueCloudMobile from '../../../images/shape-contact-us-mobile.png';
import * as globalActions from '../../../store/globalStore/actions';
import { Form } from '../components';
import styles from './styles';
import Navigation from '../../../common/Navigation/Navigation';

class ContactPage extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    setPage: PropTypes.func,
    requestPageData: PropTypes.func,
    data: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    setPage: () => { },
    requestPageData: () => { },
    data: {},
  };

  componentDidMount() {
    this.props.setPage({ current_page: 'Contact' });
    this.props.requestPageData();
  }

  componentWillUnmount() {
    this.props.setPage({ current_page: null });
  }

  contactInfo = () => {
    const { classes, data } = this.props;
    return (
      <div className={classes.contactInfoContainer}>
        <div className={classes.dataElement}>
          <span className={classes.nameText}>EMAIL</span>
          <a className={classes.phoneEmailLink} href={`mailto:${data.email}`}>
            {data.email}
          </a>
        </div>
        <div className={classes.dataElement}>
          <span className={classes.nameText}>PHONE</span>
          <a className={classes.phoneEmailLink} href={`tel:${data.phone}`}>
            {data.phone}
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { classes, data } = this.props;
    return (
      <Navigation mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <div className={classes.subContainer}>
            <MediaQuery minWidth={620}>
              {matches => (matches
                ? <img className={classes.image} src={blueCloud} alt={'blue-cloud'} />
                : <img className={classes.image} src={blueCloudMobile} alt={'cloud-mobile'} />)}
            </MediaQuery>
            <div className={classes.infoContainer}>
              <div className={classes.topInfo}>
                <div
                  role={'button'}
                  tabIndex={0}
                  onKeyPress={() => history.goBack()}
                  onClick={() => history.goBack()}
                  className={classes.arrowBackContainer}
                >
                  <ArrowBackIos />
                  <MediaQuery minWidth={700}>
                    {matches => (matches
                      ? (<div className={classes.link}>Back</div>)
                      : null)}
                  </MediaQuery>
                </div>
                <span className={classes.title}>{data.title}</span>
              </div>
              {this.contactInfo()}
            </div>
            <div className={classes.form}>
              <Form />
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: getData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: page => dispatch(globalActions.setPage(page)),
    requestPageData: () => dispatch(contactActions.requestPageData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ContactPage));
